import {
  AutoComplete,
  AutoCompleteProps
} from "@fidget/common/components/form/autoComplete/autoComplete";
import { observer } from "mobx-react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import React, { useState } from "react";
import { FieldState } from "formstate";
import classNames from "classnames";
import settingsStyles from "../../../../../../styles/settings.css";
import { caseInsensitiveIncludes } from "@fidget/common/utils/searchMatching";
import { AgentInput } from "@fidget/common/components/form/agentInput";
import { IMessageWidgetConfig } from "../../../../../../models/messageWidgets/MessageWidgetConfig";

interface Props
  extends Pick<
    AutoCompleteProps<IMessageWidgetConfig>,
    "onStateChange" | "initialIsOpen" | "onOutsideClick"
  > {
  onChange(tag: IMessageWidgetConfig): void;
  items: IMessageWidgetConfig[];
  className?: string;
  error?: string;
}

export const MessageWidgetPicker = observer(
  ({ items, onChange: onChange, className, onStateChange, initialIsOpen }: Props) => {
    const [inputField] = useState(new FieldState(""));

    return (
      <AutoComplete<IMessageWidgetConfig>
        readOnly
        onChange={onChange}
        itemToString={(val) => val?.name || ""}
        className={classNames(settingsStyles["input-max-width-bigger"], className)}
        placeholder={intl.formatMessage("settings.tagGroups.form.messageWidgets.pickPlaceholder")}
        emptyPlaceholder={intl.formatMessage(
          "settings.tagGroups.form.messageWidgets.emptyPlaceholder"
        )}
        itemsProvider={
          inputField.$
            ? () => items.filter((action) => caseInsensitiveIncludes(action.name, inputField.$))
            : () => items
        }
        onStateChange={onStateChange}
        initialIsOpen={initialIsOpen}
      >
        <AgentInput
          field={inputField}
          placeholder={intl.formatMessage(
            "settings.tagGroups.form.messageWidgets.searchPlaceholder"
          )}
        />
      </AutoComplete>
    );
  }
);
